export default function publicationsDateToggle() {
	const sidebar = document.getElementById('advanced-query-sidebar')
	if (!sidebar) {
		return
	}

	const dates = sidebar.querySelectorAll('input[type=radio][name=query-0-date]')
	dates.forEach((date) => date.addEventListener('change', () => {
		if (date.value === 'custom') {
			sidebar.querySelectorAll('input[type=date]').forEach((input) => {
				input.disabled = false
				input.setAttribute('aria-disabled', 'false')
			})
		} else {
			sidebar.querySelectorAll('input[type=date]').forEach((input) => {
				input.disabled = true
				input.setAttribute('aria-disabled', 'true')
				input.value = ''
			})
		}
	}))
}
